module.exports = __webpack_public_path__ + "static/media/Green Haven.8981bdbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-la/Green Haven.jpg
// module id = 414
// module chunks = 0